import React from 'react';
import PropTypes from 'prop-types';
import Settings from './Settings';

function SettingsContainer(props) {
  const { match, isQuestionnaireSkipped, skipInterestSelectionForm } = props;
  return (
    <Settings isQuestionnaireSkipped={isQuestionnaireSkipped || skipInterestSelectionForm} routeParams={match && match.params} />
  );
}
SettingsContainer.propTypes = {
  match: PropTypes.shape({ params: { artistId: PropTypes.string, offerId: PropTypes.string, tabId: PropTypes.string } }),
};

SettingsContainer.defaultProps = {
  match: null,
};
export default SettingsContainer;
